import { render, staticRenderFns } from "./ModalAudit.vue?vue&type=template&id=08a39242&scoped=true"
import script from "./ModalAudit.vue?vue&type=script&lang=ts"
export * from "./ModalAudit.vue?vue&type=script&lang=ts"
import style0 from "./ModalAudit.vue?vue&type=style&index=0&id=08a39242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a39242",
  null
  
)

export default component.exports